import Switch from "./Switch.styled";

export default Switch;
